import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { AuthContext } from "../AuthContext/AuthContext";
import Topbar from "../Topbar/Topbar";
import ChatWidget from "../Chat/ChatWidget";
import ModalUser from "./ModalUser";
import "./Users.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

// ─── Catálogos de visualización ──────────────────────────────────────────────
const TYPE_LABEL   = { 0: "Administrador", 1: "Cliente" };
const STATUS_LABEL = { 0: "Inactivo",      1: "Activo"  };

const Users = () => {
  const { user }   = useContext(AuthContext);
  const navigate   = useNavigate();

  const [users,           setUsers]           = useState([]);
  const [filterText,      setFilterText]      = useState("");
  const [isAddModalOpen,  setIsAddModalOpen]  = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedUser,    setSelectedUser]    = useState(null);

  // ── Guardia de privilegio ───────────────────────────────────────────────────
  useEffect(() => {
    if (!user || !user.privileges?.users) {
      navigate("/home", { replace: true });
    }
  }, [user, navigate]);

  // ── Clase CSS en body ───────────────────────────────────────────────────────
  useEffect(() => {
    document.body.classList.add("home-page");
    return () => document.body.classList.remove("home-page");
  }, []);

  // ── Carga inicial de usuarios ───────────────────────────────────────────────
  useEffect(() => {
    fetchUsers();
  }, []);

  // ── Fetch ───────────────────────────────────────────────────────────────────
  const fetchUsers = () => {
    fetch(`${API_BASE}/api/getUsers`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setUsers(data.users);
      })
      .catch((err) => console.error("Error fetching users:", err));
  };

  // ── Handlers de modales ─────────────────────────────────────────────────────
  const openAddModal  = () => setIsAddModalOpen(true);

  const closeAddModal = () => {
    setIsAddModalOpen(false);
    fetchUsers();
  };

  const handleRowClick = (row) => {
    fetch(`${API_BASE}/api/infoUser?id_user=${row.id_user}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setSelectedUser(data.user);
          setIsEditModalOpen(true);
        }
      })
      .catch((err) => console.error("Error loading user info:", err));
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedUser(null);
    fetchUsers();
  };

  // ── Columnas del DataTable ──────────────────────────────────────────────────
  const columns = [
    {
      name:     "Username",
      selector: (row) => row.username,
      sortable: true,
    },
    {
      name:     "Nombre",
      selector: (row) => row.name,
      sortable: true,
      wrap:     true,
    },
    {
      name:     "Tipo",
      selector: (row) => TYPE_LABEL[row.type] ?? row.type,
      sortable: true,
    },
    {
      name:     "Estatus",
      selector: (row) => STATUS_LABEL[row.status] ?? row.status,
      sortable: true,
    },
  ];

  // ── Filtro de búsqueda ──────────────────────────────────────────────────────
  const filteredUsers = users.filter((u) =>
    JSON.stringify(u).toLowerCase().includes(filterText.toLowerCase())
  );

  // ── Render ──────────────────────────────────────────────────────────────────
  return (
    <>
      <Topbar />
      <div className="home-container">
        <div className="content-container">

          <div className="header">
            <div className="header-title">
              <h1>Control de Usuarios</h1>
            </div>
            <div className="header-buttons">
              <button className="btn btn-primary" onClick={openAddModal}>
                Agregar
              </button>
            </div>
          </div>

          <div className="users-list">
            <p>
              Bienvenido a la sección de Control de Usuarios. Aquí podrás
              gestionar, visualizar y editar la información de los usuarios.
            </p>
            <div className="datatable-container">
              <input
                type="text"
                className="search-input"
                placeholder="Buscar..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
              <DataTable
                columns={columns}
                data={filteredUsers}
                pagination
                highlightOnHover
                striped
                onRowClicked={handleRowClick}
                paginationComponentOptions={{
                  rowsPerPageText: "Registros por página",
                  rangeSeparatorText: "de",
                }}
              />
            </div>
          </div>

        </div>
      </div>

      {/* Modal — agregar */}
      <ModalUser
        isOpen={isAddModalOpen}
        onRequestClose={closeAddModal}
      />

      {/* Modal — editar */}
      {isEditModalOpen && (
        <ModalUser
          isOpen={isEditModalOpen}
          onRequestClose={closeEditModal}
          userData={selectedUser}
          isEditMode={true}
        />
      )}

      {/* Asistente (solo administradores con chat_token) */}
      <ChatWidget />
    </>
  );
};

export default Users;